import { render } from "./ValueRestrictionView.vue?vue&type=template&id=7021dfcc&scoped=true"
import script from "./ValueRestrictionView.vue?vue&type=script&lang=js"
export * from "./ValueRestrictionView.vue?vue&type=script&lang=js"

import "./ValueRestrictionView.vue?vue&type=style&index=0&id=7021dfcc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7021dfcc"]])

export default __exports__